module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'text-align': 'center',
      'margin': 'auto'
    }),
    attrs: {
      "id": "pdfvuer"
    }
  }, [_c('ScaleOut', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.pdfLoading),
      expression: "this.$store.state.pdfLoading"
    }],
    staticClass: "loading-icon"
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.pdfDataLoad),
      expression: "this.$store.state.pdfDataLoad"
    }],
    staticClass: "fullscreen-btn",
    attrs: {
      "title": _vm.fullscreentitle
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('img', {
    staticClass: "fullscreen-icon",
    attrs: {
      "src": require("../../assets/icon/ic_fullscreen.png"),
      "alt": "F"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.pdfDataLoad),
      expression: "this.$store.state.pdfDataLoad"
    }],
    staticClass: "ui grey three item inverted bottom fixed menu transition",
    attrs: {
      "id": "buttons"
    }
  }, [_c('a', {
    staticClass: "item"
  }, [_vm._v("\n      " + _vm._s(_vm.current) + " / " + _vm._s(_vm.totalPage ? _vm.totalPage : '∞') + "\n    ")])]), _vm._v(" "), _c('LazyPdfVuer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.pdfDataLoad),
      expression: "this.$store.state.pdfDataLoad"
    }],
    attrs: {
      "options": _vm.pdfOptions,
      "offscreenPages": "1"
    },
    on: {
      "pageChanged": _vm.onPageChanged
    }
  }), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.pdfView),
      expression: "hint.display && this.$store.state.hintStatus.pdfView"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  }), _vm._v(" "), (_vm.systemAdminMode === false) ? _c('WaterMark', {
    attrs: {
      "inputText": _vm.inputText
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.pdfError),
      expression: "this.$store.state.pdfError"
    }],
    staticStyle: {
      "margin-top": "30px",
      "font-size": "18px"
    }
  }, [_vm._v("\n    The file could not be loaded, either because the preview data is processing, please try again later or because the file is not existed or the format is not supported.\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0588be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/PDF.vue
// module id = 929
// module chunks = 170